
import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class ProjectDocumentDto extends EpimsBaseEntityDto {

  @IsNotEmpty() ProjectDocumentId: string;
  @IsNotEmpty() DocumentTitle: string;
  @IsNotEmpty() DocumentName: string;
  @IsNotEmpty() DocumentDescription: string;
  @IsNotEmpty() Amount: number;
  @IsNotEmpty() InvoiceNo: string;
  @IsNotEmpty() PaymentDate: Date;
  @IsNotEmpty() PaymentDescription: string;
  @IsNotEmpty() ProjectId: string;
  @IsNotEmpty() ProjectCategoryId: string;
  @IsNotEmpty() ProjectTypeId: string;
  @IsNotEmpty() GMOUNameId: string;
  @IsNotEmpty() DocumentSubCategoryId: string;
  @IsNotEmpty() DocumentCategoryId: string;
  @IsNotEmpty() DocumentVersion: string;
  @IsNotEmpty() DocumentRemarks: string;
  @IsNotEmpty() VirualPath: string;
  @IsNotEmpty() PhysicalPath: string;
  @IsNotEmpty() PhyscialFileLocationId: string;


}
